import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { CONFIRMATION } from "src/constants/UrlConstants";
import { useSellNavigation } from "src/pages/NewSelll/utils/useSellNavigation";
import { ROUTE_PATHS } from "src/utils/constants";
import useResponsive from "src/utils/useResponsive";

export type HeaderIconFormat = "arrow" | "close";
export type HeaderIconType = "close" | "arrow" | "close_cart";

export const useHeaderIconType = () => {
  const { WS } = useResponsive();
  const { pathname, search } = useLocation();
  const sellNavigation = useSellNavigation();

  const headerIconType: HeaderIconType = useMemo(() => {
    if (!WS) return "close";

    const params = new URLSearchParams(search);
    const isConfirmation = params.get(CONFIRMATION) === "true";

    if (isConfirmation) return "close";

    if (
      pathname.includes(ROUTE_PATHS.CART) ||
      sellNavigation?.icon === ("close" as HeaderIconFormat)
    )
      return "close";

    if (pathname.includes(ROUTE_PATHS.PAYMENT_CONFIRMATION)) return "close_cart";

    const isProducts = pathname.includes(`${ROUTE_PATHS.PRODUCTS}/`);
    const isBundlePage = pathname.includes(`${ROUTE_PATHS.BUNDLE}/`);
    const isCommunicationPage = pathname.includes(
      `${ROUTE_PATHS.COMMUNICATION}/`,
    );

    return !isProducts || isBundlePage || isCommunicationPage
      ? "arrow"
      : "close";
  }, [WS, pathname, search, sellNavigation?.icon]);

  return { headerIconType };
};
